import { Box, Text } from '@chakra-ui/react'
import { FC, useCallback, useState } from 'react'
import { OptionsType } from 'react-select'
import { AsyncPaginate } from 'react-select-async-paginate'

import api from '@config/api'

import { FilterProps } from '@base/@types/components/Shared/Filter'

interface IOptionsSelectedProps {
  label: string
  value: string | number
}

interface SelectAsyncPaginateFromApiProps extends FilterProps {
  apiUrl: string
  labelField?: string // padrão: "descricao"
  valueField?: string // padrão: "id"
}

const SelectAsyncPaginateFromApi: FC<SelectAsyncPaginateFromApiProps> = ({
  label = '',
  value = [],
  isMulti = false,
  isLoading = false,
  isDisabled = false,
  isRequired = false,
  onChange = null,
  limit,
  apiUrl,
  labelField = 'descricao',
  valueField = 'id'
}) => {
  const take = 10
  const [internalLoading, setInternalLoading] = useState(false)

  const handleOnChange = (
    values: IOptionsSelectedProps | OptionsType<IOptionsSelectedProps>
  ) => {
    onChange &&
      onChange(limit && Array.isArray(values) ? values.slice(0, limit) : values)
  }

  const loadOptions = useCallback(
    async (inputValue: string, _loadedOptions: any, { page }: any) => {
      const skip = (page - 1) * take
      setInternalLoading(true)

      try {
        const params = {
          take,
          skip,
          ...(inputValue ? { search: inputValue } : {})
        }

        const response = await api.get(apiUrl, { params })

        const options: IOptionsSelectedProps[] = (
          response.data?.data || []
        ).map((item: any) => ({
          label: String(item[labelField]),
          value: item[valueField]
        }))

        const hasMore = options.length === take

        return {
          options,
          hasMore,
          additional: {
            page: page + 1
          }
        }
      } catch (err) {
        return { options: [], hasMore: false, additional: { page: page + 1 } }
      } finally {
        setInternalLoading(false)
      }
    },
    [apiUrl, labelField, valueField]
  )

  return (
    <Box w="100%">
      {label && (
        <Text mb={2} fontSize="sm" color="black">
          {label}
        </Text>
      )}
      <AsyncPaginate
        value={value}
        loadOptions={loadOptions}
        additional={{ page: 1 }}
        getOptionValue={option => option.value.toString()}
        getOptionLabel={option => option.label}
        classNamePrefix="react-select"
        isSearchable
        isMulti={isMulti}
        onChange={handleOnChange}
        placeholder="Selecione..."
        isDisabled={isDisabled}
        isLoading={isLoading || internalLoading}
        isRequired={isRequired}
        closeMenuOnSelect
        loadingMessage={() => 'Carregando...'}
      />
    </Box>
  )
}

export default SelectAsyncPaginateFromApi
